import React from 'react';
import { Button } from '../ui/button';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

export const Pagination = ({ page, pages, total, limit, onPageChange }) => {
  if (pages <= 1) return null;

  return (
    <div className="flex items-center justify-between pt-4 border-t border-border" data-testid="pagination">
      <p className="text-sm text-muted-foreground">
        Showing {Math.min((page - 1) * limit + 1, total)}–{Math.min(page * limit, total)} of {total}
      </p>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(1)} data-testid="pagination-first">
          <ChevronsLeft className="w-4 h-4" />
        </Button>
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)} data-testid="pagination-prev">
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <span className="px-3 py-1 text-sm font-medium">{page} / {pages}</span>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => onPageChange(page + 1)} data-testid="pagination-next">
          <ChevronRight className="w-4 h-4" />
        </Button>
        <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => onPageChange(pages)} data-testid="pagination-last">
          <ChevronsRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};
